/**
 * Shopify Homepage Fold-by-Fold Lazy Load (FIXED)
 * Safe for layout & accessibility
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ===============================
   * 1. CONFIG
   * =============================== */

  const EXCLUDED_SECTION_IDS = [
    'shopify-section-static-minimal-header',
    'shopify-section-static-slideshow'
  ];

  const ROOT_MARGIN = '150px';


  /* ===============================
   * 2. SELECT ONLY REAL SECTIONS
   * =============================== */

  const lazySections = Array.from(
    document.querySelectorAll('main#site-main > .shopify-section')
  ).filter(section => {
    return !EXCLUDED_SECTION_IDS.includes(section.id);
  });


  /* ===============================
   * 3. APPLY LAZY CLASS
   * =============================== */

  lazySections.forEach(section => {
    section.classList.add('lazy-fold');
  });


  /* ===============================
   * 4. OBSERVER
   * =============================== */

  if (!('IntersectionObserver' in window)) {
    lazySections.forEach(section => section.classList.add('loaded'));
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('loaded');
        obs.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: ROOT_MARGIN,
    threshold: 0
  });

  lazySections.forEach(section => observer.observe(section));


  /* ===============================
   * 5. IMAGE LAZY LOAD (OPTIONAL)
   * =============================== */

  const lazyImages = document.querySelectorAll('img[data-src]');

  if ('IntersectionObserver' in window && lazyImages.length) {
    const imgObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          obs.unobserve(img);
        }
      });
    }, {
      rootMargin: '200px'
    });

    lazyImages.forEach(img => imgObserver.observe(img));
  }

});
